import { IBar, INote, IScoreEditorThis } from "../../../../../common/types";

export function handleSolfaRemove(this: IScoreEditorThis) {
  const { activeVoice } = this.state;
  const score = { ...this.state.score };
  const bars = score["bars" + (activeVoice || "")] as IBar[];
  let bar: number;
  let note: number;
  let find = false;
  if (this.state.selectedNote) {
      find = true;
      ({ bar, note } = this.state.selectedNote);
      if (!bars[bar]?.notes?.[note]?.p) {
          while (bars[bar]?.notes?.[note]?.p) {
              if (note !== 0) {
                  note--;
              } else {
                  bar--;
                  if (!bars[bar]) return;
                  note = bars[bar].notes.length - 1;
              }
          }
          this.setState({ selectedNote: { bar, note } });
      }
  } else {
      bar = bars.length - 1;
      outer: for (let b = bar; b >= -1; b--) {
          if (b === -1 || bars[b] === null) return;
          bar = b;
          note = bars[bar].notes.length - 1;
          for (let n = note; n >= 0; n--) {
              note = n;
              if (bars[b].notes[n].p !== undefined) {
                  find = true;
                  break outer;
              }
          }
      }
  }
  if (bar === undefined || !find) return;
  let currentNote = bars[bar].notes[note!];
  delete currentNote.p;
  let beforeNote = getBeforeNote(bars, bar, note!);
  if (beforeNote.tie) {
      delete beforeNote.p;
  }
  this.setState({ score });
}

// TODO prevBar
const getBeforeNote = (bars: IBar[], bar: number, note: number): INote => {
  if (note === 0) return { l: 4 };
  return bars[bar].notes[note - 1];
};